import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-datenschutz',
  standalone: true,
  imports: [LegalLayoutComponent, RouterLink],
  templateUrl: './datenschutz.component.html',
})
export class DatenschutzComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Datenschutzerklärung · Craftly',
      description: 'Informationen zur Verarbeitung personenbezogener Daten auf der Craftly-Plattform gemäß DSGVO.',
      path: '/datenschutz',
      type: 'article',
    });
  }
}
